import { FilterMatchMode } from 'primereact/api';

export const tableFilters = {
  armador: { value: null, matchMode: FilterMatchMode.CONTAINS },
  tipo: { value: null, matchMode: FilterMatchMode.CONTAINS },
  tamano: { value: null, matchMode: FilterMatchMode.CONTAINS },
  contenedor: { value: null, matchMode: FilterMatchMode.CONTAINS },
  booking: { value: null, matchMode: FilterMatchMode.CONTAINS },
  playa: { value: null, matchMode: FilterMatchMode.CONTAINS },
  estado: { value: null, matchMode: FilterMatchMode.CONTAINS },
  tara: { value: null, matchMode: FilterMatchMode.CONTAINS },
  mgw: { value: null, matchMode: FilterMatchMode.CONTAINS },
  payLoad: { value: null, matchMode: FilterMatchMode.CONTAINS },
  viajeImport: { value: null, matchMode: FilterMatchMode.CONTAINS },
  llegadaImport: { value: null, matchMode: FilterMatchMode.DATE_IS },
  viajeExport: { value: null, matchMode: FilterMatchMode.CONTAINS },
  llegadaExport: { value: null, matchMode: FilterMatchMode.DATE_IS },
  estadia: { value: null, matchMode: FilterMatchMode.CONTAINS },
  statusExport: { value: null, matchMode: FilterMatchMode.CONTAINS },
  bloqueos: { value: null, matchMode: FilterMatchMode.CONTAINS },
};
